import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const DataContext = createContext(null);

const TYPES = ["news", "documents", "sponsors", "schedule", "faq", "spectators", "contacts", "history", "infosections", "videos"];

export function DataProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const [s, ...lists] = await Promise.all([api.getSettings(), ...TYPES.map((t) => api.list(t).catch(() => []))]);
    setSettings(s);
    const next = {};
    TYPES.forEach((t, i) => (next[t] = lists[i]));
    setData(next);
    setLoading(false);
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <DataContext.Provider value={{ settings, data, loading, refresh, setSettings }}>
      {children}
    </DataContext.Provider>
  );
}

export const useData = () => useContext(DataContext);
